import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";

import CSSModules from "react-css-modules";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Route, Switch } from "react-router";
import ImportOverview from "../ImportOverview/ImportOverview";
import MasterRulesOverview from "../MasterRulesOverview/MasterRulesOverview";

@CSSModules(styles, { allowMultiple: true })
class MasterRules extends Component {

  constructor(props) {

    super(props);
    this.state = {
    };
  }

  componentDidMount() {

  }

  render() {

    return (
      <div className={"master-rule-variables-enable"}>

				<div styleName="header">
          <div styleName="mode-switcher">
            <h1 style={{margin: 0, marginRight: '2rem'}}>Master Rules Manager</h1>
            <div styleName="mode-switch-buttons">
              <div>
                <Link to={`/MasterRules/Import`}>Import</Link>
              </div>
              <div>
                <Link to={`/MasterRules/All`}>Master Rules</Link>
              </div>
            </div>

          </div>


				</div>

        <Switch>
          <Route path={`/MasterRules/Import`}>
            <ImportOverview key="import-route-view"></ImportOverview>
          </Route>
          <Route path={`/MasterRules/`}>
            <MasterRulesOverview key="master-rules-overview"></MasterRulesOverview>
          </Route>
        </Switch>

      </div>
    );
  }
}

const bindAction = dispatch => {
  return {
    navigate: (uri, data) => dispatch(router.push(uri, data)),
    goBack: () => dispatch(router.goBack())
  };
};

const mapStateToProps = state => ({
});

export default connect(
  mapStateToProps,
  bindAction
)(MasterRules);



// WEBPACK FOOTER //
// ./src/ui/MasterRules/MasterRules.js